
import React from 'react';
import { PopupContext } from "./PopupContext";
import { OptionPopupMenu } from "./OptionPopupMenu";
import { Popup } from "../../../lib/onboarding-shared/popup";

const SHOW_POPUP_MOUSE_OVER = "SHOW_POPUP_MOUSE_OVER";
const SHOW_POPUP_BUTTON_CLICK = "SHOW_POPUP_BUTTON_CLICK";

class OptionPopupButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mouse_over_button: false,
      mouse_over_popup: false,
    }
  }

  onPopupMouseOver = (id, mouse_over) => ev => {
    //console.log("onPopupMouseOver", id, mouse_over);
  };

  onPopupClick = (menu_id, button_id) => {
    this.setState({ mouse_over_button: false});
    this.props.on_click(menu_id, button_id);
  }

  getPopupBehavior = () => {
    return this.props.show_popup_behavior || SHOW_POPUP_MOUSE_OVER;
  }


  onButtonMouseOver = (mouse_over) => ev => {
    if (this.getPopupBehavior() === SHOW_POPUP_MOUSE_OVER && mouse_over) {
      this.setState({ mouse_over_button: true});
    } else {
      this.setState({ mouse_over_button: false});
    }
  };

  onButtonClick = () => {
    if (this.getPopupBehavior() === SHOW_POPUP_BUTTON_CLICK) {
      this.setState({ mouse_over_button: !this.state.mouse_over_button});
    }
  }

  render = () => {
    const provider_state = {
      onMouseOver: this.onPopupMouseOver,
      onPopupMenuClick: this.onPopupClick,
    };

    const show_popup = this.state.mouse_over_button || this.state.mouse_over_popup;
    const client_colors = this.props.client ? {
      color: {
        background: this.props.client.color.banner_background,
        text: this.props.color.banner_text,
        model: "dark",
      },
    } : {};

    const popup = (
      <Popup
        style={this.props.popup_style}
        popup_id={this.props.menu_id}
        onMouseOver={this.onPopupMouseOver}>
        <OptionPopupMenu
          style={this.props.menu_button_style}
          menu_id={this.props.menu_id}
          client={client_colors}
          buttons={this.props.buttons}/>
      </Popup>);

    return (
      <PopupContext.Provider value={provider_state}>
        <div
          style={this.props.button_style}
          onMouseEnter={this.onButtonMouseOver(true)}
          onMouseLeave={this.onButtonMouseOver(false)}>
          <div onClick={this.onButtonClick}>
            { this.props.children }
          </div>
          { show_popup && popup }
        </div>
      </PopupContext.Provider>
    );
  }
}

export { OptionPopupButton, SHOW_POPUP_MOUSE_OVER, SHOW_POPUP_BUTTON_CLICK };
